import React from "react";

class TextGlowSVG extends React.Component {
  render() {
    let { glowColor, idCSS, rotation = 0 } = this.props;

    let gradientTransform = `rotate(${rotation})`;

    return (
      <svg style={{ height: 0 }}>
        <defs>

        <filter id={idCSS} height="300%" width="300%" x="-75%" y="-75%">
          <feMorphology operator="dilate" radius="1" in="SourceAlpha" result="thicken" />

          <feGaussianBlur in="thicken" stdDeviation="10" result="blurred" />

          <feFlood flood-color={glowColor} result="glowColor" />

          <feComposite in="glowColor" in2="blurred" operator="in" result="softGlow_colored" />

          <feMerge>
            <feMergeNode in="softGlow_colored"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>

        </filter>
        
        </defs>
      </svg>
    );
  }
}

export default TextGlowSVG;
